import { TLibraryOB } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';

export const OB_LIST_TABLE_MODEL = {
  createModel: (items: TLibraryOB[], obPath: (id: string) => string) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        headerConfig: [
          { type: 'TEXT_CELL', text: 'OB Code' },
          { type: 'TEXT_CELL', text: 'Product Type' },
          { type: 'TEXT_CELL', text: 'Style No.' },
          { type: 'TEXT_CELL', text: 'Short Description' },
          { type: 'TEXT_CELL', text: 'Status' },
          { type: 'TEXT_CELL', text: 'SMV' },
          { type: 'TEXT_CELL', text: '', stickyType: 'RIGHT', widthInPx: 50 },
        ],
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            { type: 'TEXT_CELL', text: item.code, href: obPath(item.id) },
            { type: 'TEXT_CELL', text: item.productTypeName },
            { type: 'TEXT_CELL', text: item.styleNo },
            { type: 'TEXT_CELL', text: item.shortDescription },
            { type: 'TEXT_CELL', text: item.status },
            { type: 'TEXT_CELL', text: item.smv },
            {
              type: 'ACTION_LIST_CELL' as const,
              title: '',
              actions: [
                { displayText: 'View', type: 'VIEW' },
                { displayText: 'Edit', type: 'EDIT' },
                { displayText: 'Duplicate', type: 'DUPLICATE' },
                { displayText: 'Add OB Planning', type: 'ADD_OB_PLANNING' },
              ],
            },
          ],
        };
      },
    );
  },
};
